export default __webpack_public_path__ + "static/4-f2f7c9a79be45387704779ec497405e3.jpeg";